import * as $ from 'jquery';
import { SVG } from '@svgdotjs/svg.js';
import { initPlaceholders, initMaskedInput } from '../form/inputs';
import {numberFormat} from "../helpers";
import InitGarageFeedbackForm from '../feedback-form/init-garage-feedback-form';

export default class GarageSectionsSelect {
   constructor($block) {
      this.$block = $block;
      this.$drawingBlock = $block.find('[garage-drawing_block]');
      this.$drawing = $block.find('[garage-data-drawing]');
      /* this.$sectionsDrawing = $block.find('gp_drawing'); */

      if (!this.$drawing.length) return false;

      this.desktop = null;

      this.items = JSON.parse(this.$drawing.attr('data-items'));
      this.drawingItems = [];

      this.drawingOptions = {
         id: this.$drawing.attr('id'),
         image: this.$drawing.attr('data-image'),
         colorBase: 'rgba(39,186,54,0)',
         colorSold: 'rgba(255, 255, 255)',
         colorReserved: 'rgba(243,243,243)',
         colorFill: 'rgba(37,237,53,0.4)',
         strokeBase: { color: 'rgba(39,186,54,0.4)', opacity: 0.5, width: 0 },
         strokeFill: { color: '#fff', opacity: 0.7, width: 0 },

         width:   +this.$block.attr('data-width'),
         height: +this.$block.attr('data-height'),
      }

      this.init();
   }
   init() {
      this.checkData();
      this.$popupInfo = this.createPopup();
      this.$popupInfoContent = this.$popupInfo.find('.content');

      this.$formInfo = this.createForm();
      this.$formInfoContent = this.$formInfo.find('.garage_form_content')

      this.zoom = 100;
      this.zoomStep = 100;
      this.zoomOutBtn = $('body').find('[data-zoom-out]');
      this.zoomInBtn = $('body').find('[data-zoom-in]');

      try {
         const viewer = new TouchScroll();
         if (this.isDesktop) {
            viewer.init({
               id: 'gp_sections_drawing',
               draggable: true,
               wait: false
            });
         }
      } catch (e) {
         console.warn(e)
      }

      this.draw = this.drawingInit();
      this.addDrawingItems();
      this.drawingResize();
      $(window)
         .on('mousemove', (e) => {
            this.setPopupPosition(e);
         })
         .on('resize', (e) => {
            this.drawingResize();
            this.initEventsHandler();
         });

      // закрытие тултипа
      $('body').on('click', '[data-close-popup-info]', () => {
         this.hidePopup();
         return false;
      });

      //закрытие формы
      $('body').on('click', '[data-close-form]', () => {
         this.closeForm();
         return false;
      });

      // при скроле удаляем кнопку Перемещайте генплан на моб.версии
      this.$drawingBlock.on('scroll', () => {
         if (this.$block.find('.move-button').length) {
            this.$block.find('.move-button').remove();
         }
      });

      this.initEventsHandler();
   }
   checkData () {
      this.items.forEach((e) => {
         if(e['rotate'] === null ) {
            e['rotate'] = '0';
         }

         $.each(e, function (key , val) {
            if(e[key] === null ) {
               e[key] = '';
            }
         })
         switch (e['state']) {
            case "1":
               e['state'] = 'В продаже'
               break;
            case "2":
               e['state'] = 'Забронировано'
               break;
            case "3":
               e['state'] = 'Продано'
               break;
         }
      })
   }

   initEventsHandler() {
      const desktop = this.isDesktop();
      if (desktop !== this.desktop) this.desktop = desktop;

      this.$block.off('mouseenter', '.item');
      this.$block.off('mouseleave', '.item');
      this.$block.off('click', '.item');

      if (this.desktop) {
         this.$block
            .on('mouseenter', '.item', e => {
               const id = e.currentTarget.dataset['id'];
               this.handlerMouseenter(this.drawingItems[id]);
            })
            .on('mouseleave', '.item', e => {
               const id = e.currentTarget.dataset['id'];
               this.handlerMouseleave(this.drawingItems[id]);
            })
            .on('click', '.item', e => {
               const id = e.currentTarget.dataset['id'];
               this.handlerClick(this.drawingItems[id]);
               return false;
            });

      } else {
         this.$block.on('click', '.item', e => {
            const id = e.currentTarget.dataset['id'];
            this.handlerClickMobile(this.drawingItems[id]);
            return false;
         });
      }

      this.drawingItems.forEach((item) => {
         item.off('click');
         item.off('mouseenter');
         item.off('mouseleave');

         if (this.desktop) {
            item
               .on('mouseenter', () => {
                  this.handlerMouseenter(item);
               })
               .on('mouseleave', () => {
                  this.handlerMouseleave(item);
               })
               .on('click', () => {
                  this.handlerClick(item);
               });

         } else {
            item.on('click', () => {
               this.handlerClickMobile(item);
               return false;
            });
         }
      })
   }


   drawingInit() {
      const draw = SVG().addTo(`#${this.drawingOptions.id}`);
      draw.viewbox(0, 0, this.drawingOptions.width, this.drawingOptions.height);

      const image = draw.image(this.drawingOptions.image);
      image.size('100%', '100%').move(0, 0);

      //zoom out

      $('body').on('click', '[data-zoom-out]', () => {
         if (this.zoom == 100) {
            this.$drawing.css('overflow', 'hidden');
            return false;
         }

         this.$drawing.css('overflow', 'auto');

         if (this.zoom == 400) {
            this.zoomInBtn.css("background-color", "#ee1d33");
         }
         this.zoom -= this.zoomStep;
         this.draw.css("width", `${this.zoom}%`);

         if (this.zoom == 100) {
            this.$drawing.css('overflow', 'hidden');
            this.zoomOutBtn.css("background-color", "#e5e5e5");
         }
         return false;
      })

      //zoom in 
      $('body').on('click', '[data-zoom-in]', () => {

         if (this.zoom > 390) {
            return false;
         }
         this.$drawing.css("overflow", "auto");
         this.zoomInBtn.css("background-color", "#ee1d33");
         this.zoom += this.zoomStep;
         this.draw.css("width", `${this.zoom}%`);
         if (this.zoom > 100) {
            this.zoomOutBtn.css("background-color", "#ee1d33");
         }
         if (this.zoom > 390) {
            this.zoomInBtn.css("background-color", "#e5e5e5");
         }
         return false;
      })

      return draw;
   }
   //1-В продаже 2-Бронь 3-Продано
   drawingResize() {
      const kHW = this.drawingOptions.height / this.drawingOptions.width;
      const kWH = this.drawingOptions.width / this.drawingOptions.height;
      const blockWidth = this.$block.width();
      const blockHeight = this.$block.height();
      const kBlock = blockHeight / blockWidth;

      let widthDrawing = blockWidth;
      let heightDrawing = blockWidth * kHW;
      let maxHeightDrawing = blockWidth * kHW;

      if (widthDrawing < 1000) {
         heightDrawing = 480;
         widthDrawing = heightDrawing * kWH;
      }

      let scale = widthDrawing / 1920 + 0.2;
      if (scale > 1) scale = 1;
      this.$block.find('.item').css({
         'transform': `translateX(-50%) translateY(-50%) scale(${scale})`
      });

      this.$drawing.css({
         width: `${widthDrawing}px`,
         height: `${heightDrawing}px`,
         marginLeft: `${-widthDrawing / 2}px`,
         marginTop: `${-heightDrawing / 2}px`
      });

      this.$drawing.attr('style', `max-height: ${maxHeightDrawing}px !important`);

   }

   addDrawingItems() {
      for (let i = 0; i < this.items.length; i++) {
         const item = this.items[i];
         if (!item.id) continue;
         this.addItemSVG(item);
      }
   }

   addItemSVG(item = {}) {
      const {
         id = null,
         name = '',
         position = '',
         coords = '',
         state = '',
         href = '',
         cost = '',
         length = '',
         square = '',
         width = '',
         numberCoords = '',
         rotate = '',
      } = item;
      this.drawingItems[id] = this.draw.polygon(coords);
      this.drawingItems[id].data({id});

      const isMititevGarages = $('[data-mitirev]').length;
      let elem = $(`polygon[data-id="${id}"]`);

         if(isMititevGarages){
            //координаты центра блока относительно svg (для центровки текста)

            let textSVGDOM,
                textX,
                textY;

            switch (item['state']) {
               case 'В продаже':
                  this.drawingItems[id].fill(this.drawingOptions.colorBase)
                      .stroke(this.drawingOptions.strokeBase);
                  break;
               case 'Продано':
                  this.drawingItems[id].fill(this.drawingOptions.colorSold)
                      .stroke("#3333")
                  this.drawingItems[id].after(`<text data-text-id="${id}" font-size="22" style="pointer-events:none;" fill="#3333" transform="rotate(${item['rotate']})">${item['name']}</text>`);
                  textSVGDOM = $(`text[data-text-id="${id}"]`);
                  textX = elem[0].getBBox().x + elem[0].getBBox().width / 2 - textSVGDOM[0].getBBox().width / 2;
                  textY = elem[0].getBBox().y + elem[0].getBBox().height / 2 + textSVGDOM[0].getBBox().height / 2 - 5;

                  if(+item['rotate'] === -90){
                     textX = elem[0].getBBox().x + textSVGDOM[0].getBBox().height + elem[0].getBBox().width / 2 - textSVGDOM[0].getBBox().height / 2 - 4;
                     textY = elem[0].getBBox().y + textSVGDOM[0].getBBox().width + elem[0].getBBox().height / 2 - textSVGDOM[0].getBBox().width / 2;
                     $(textSVGDOM).attr('transform',`translate(${textX} ${textY}) rotate(-90)`)
                  }else{
                     $(textSVGDOM).attr('transform',`translate(${textX} ${textY})`)
                  }

                  break;
               case 'Забронировано':
                  this.drawingItems[id].fill(this.drawingOptions.colorReserved)
                      .stroke("#000");
                  this.drawingItems[id].after(`<text data-text-id="${id}" font-size="22" style="pointer-events:none;" fill="#000" transform="rotate(${item['rotate']})">${item['name']}</text>`);
                  textSVGDOM = $(`text[data-text-id="${id}"]`);
                  textX = elem[0].getBBox().x + elem[0].getBBox().width / 2 - textSVGDOM[0].getBBox().width / 2;
                  textY = elem[0].getBBox().y + elem[0].getBBox().height / 2 + textSVGDOM[0].getBBox().height / 2 - 5;

                  if(+item['rotate'] === -90){
                     textX = elem[0].getBBox().x + textSVGDOM[0].getBBox().height + elem[0].getBBox().width / 2 - textSVGDOM[0].getBBox().height / 2 - 4;
                     textY = elem[0].getBBox().y + textSVGDOM[0].getBBox().width + elem[0].getBBox().height / 2 - textSVGDOM[0].getBBox().width / 2;
                     $(textSVGDOM).attr('transform',`translate(${textX} ${textY}) rotate(-90)`)
                  }else{
                     $(textSVGDOM).attr('transform',`translate(${textX} ${textY})`)
                  }

                  break;
            }

         }else{
            switch (item['state']) {
               case 'В продаже':
                  this.drawingItems[id].fill(this.drawingOptions.colorBase)
                      .stroke(this.drawingOptions.strokeBase);
                  if(item['numberCoords'] && item['numberCoords'] !== '' && item['numberCoords'] !== undefined){
                     this.drawingItems[id].after(`<text style="pointer-events:none;" fill="#fff" transform="translate(${item['numberCoords']}) rotate(${item['rotate']})">${item['name']}</text>`);
                  }
                  break;
               case 'Продано':
                  this.drawingItems[id].fill(this.drawingOptions.colorSold)
                      .stroke("#3333")
                  if(item['numberCoords'] && item['numberCoords'] !== '' && item['numberCoords'] !== undefined){
                     this.drawingItems[id].after(`<text style="pointer-events:none;" fill="#3333" transform="translate(${item['numberCoords']}) rotate(${item['rotate']})">${item['name']}</text>`);
                  }
                  break;
               case 'Забронировано':
                  this.drawingItems[id].fill(this.drawingOptions.colorReserved)
                      .stroke("#000");
                  if(item['numberCoords'] && item['numberCoords'] !== '' && item['numberCoords'] !== undefined){
                     this.drawingItems[id].after(`<text style="pointer-events:none;" fill="#000" transform="translate(${item['numberCoords']}) rotate(${item['rotate']})">${item['name']}</text>`);
                  }
                  break;
            }
         }
      this.drawingItems[id].style('cursor', 'pointer');
      this.drawingItems[id].data({
         name,
         coords,
         position,
         state,
         href,
         cost,
         length,
         square,
         width,
         numberCoords,
         rotate,
      })
   }

   /**
     * Обработчик наведения на объект
     * @param {Object} item - svg.js объект
     */
   handlerMouseenter(item) {
      if(item.data('state') === 'В продаже') {
         item.fill(this.drawingOptions.colorFill);
         item.stroke(this.drawingOptions.strokeFill);
      }
      this.setDataPopup(item);
      this.showPopup();
   }

   /**
    * Обработчик ухода курсора с объекта
    * @param {Object} item - svg.js объект
    */
   handlerMouseleave(item) {
      if(item.data('state') === 'В продаже') {
         item.fill(this.drawingOptions.colorBase);
         item.stroke(this.drawingOptions.strokeBase);
      }
      this.hidePopup();
   }

   /**
     * Обработчик клика на объект - десктоп
     * @param {Object} item - svg.js объект
     */
   handlerClick(item) {
      /*  window.location.href = item.data('href'); */
      /* const { width, length, square, cost, state } = item.node.dataset; */
      if(item.data('state') === 'В продаже') {
         this.setFormData(item);
         this.showForm();
         $('body').addClass('gp_hidden');
         return false;
      }
   }

   closeForm() {
      this.$formInfo.removeClass('show show-effect');
      this.clearForm();
      $('body').removeClass('gp_hidden');
   }

   createForm() {
      $('body').append(`
          <div id="form_info" class="garage_form_info">
              <div class="garage_form_content"></div>
          </div>
      `);

      return $('#form_info');
   }

   setFormData(item = {}) {
      let { width, length, square, cost, name } = item.node.dataset;
      console.log(width)
      let string = '';
      if(width !== '' && length !== '') {
         string = `<p class="form-text color-text-gray">Длина: <span class="form-text-units">${length} м</span></p>
         <p class="form-text color-text-gray">Ширина: <span class="form-text-units">${width} м</span></p>`;
      }
      let garageTitleHTML = $('.garage_title').text();
      let sectionWithFloorHTML = ''

      if(garageTitleHTML ==='«Дом на Митирева»'){
         sectionWithFloorHTML = `${$('.garage_active_link').text()}`;

      }else{
         sectionWithFloorHTML = `${$('.garage_active_link').text()
             .replace(/Надземный/g, '')
             .replace(/закрытый/g, '')
             .replace(/Подземный/g, '')
             .slice(1)
         }`;
      }

      const htmlForm = `
      <div class="garage_form_container" style="left:0;top:${window.pageYOffset}px">
         <div class="garage_form">
         <p class ="form-text-big ">Заявка на бронирование</p>
         <a href="#" class="form_close" data-close-form><i class="icon icon-close1"></i></a>
         <p class ="form-text color-text-gray form-first-text">${garageTitleHTML} Подземный</p>
         <p class="form-text color-text-gray form-first-text">${sectionWithFloorHTML}, Место № ${name}</p>
         <p class="form-text color-text-gray">Площадь: <span class="form-text-units">${square} м²</span></p>` +
         string +
         `<p class="form-text-cost color-main-active">${numberFormat(cost,0,'',' ')} ₽</p>
         <form action="" id="gp_form" class="feedback-form">
                    <label class="field field-input item">
                        <input class="input-text placeholder validate" data-placeholder="Как к вам обращаться" data-validate="required" id="reserve_name"
                               name="reserve_name" type="text">
                        <p class="error-message"></p>
                    </label>

                    <label class="field field-input item">
                        <input class="input-text placeholder validate input-mask" data-mask_tpl="phone_plus7"
                               data-placeholder="Номер телефона" data-validate="mobile_phone" id="reserve_phone"
                               name="reserve_phone" type="text" value="" inputmode="text">
                        <p class="error-message"></p>
                    </label>

                    <div class="form-message">
                        <div class="form-info">
                            <span class="message-icon success"><i class="icon-confirm"></i></span>
                            <span class="message-icon error"><i class="icon-cancel"></i></span>
                            <p class="message-title"></p>
                            <p class="message-subtitle"></p>
                        </div>
                    </div>

                    <button class="button no-margin-top delay-500" type="submit">Отправить</button>
                </form>
                <p class="form-text color-text-gray text-align-center no-margin font-size-medium form-number-specialist">Телефон специалиста</p>
                <p class="text-align-center no-margin font-size-smaller form-number">+7 846 993 83 60</p>
         </div>
      </div>
   `;
      this.$formInfoContent.html(htmlForm);
      initPlaceholders();
      initMaskedInput();
      new InitGarageFeedbackForm();
   }

   showForm() {
      this.$popupInfo.addClass('show');
      setTimeout(() => {
         this.$popupInfo.addClass('show-effect');
      }, 5);
      if (!this.desktop) {
         $('body').addClass('gp_hidden');
      }
   }

   /**
    * Обработчик клика на объект - мобильные устройства
    * @param {Object} item - svg.js объект
    */
   handlerClickMobile(item) {
      // открываем попап
      this.setDataPopup(item);
      this.showPopup();
      $('body').on('click', '[data-open-form]', () => {
         setTimeout(() => this.hidePopup(), 100);

         this.setFormData(item);
         this.showForm();

         return false;
      })
   }

   /**
      * Определение десктопа
      * @returns {boolean}
      */
   isDesktop() {
      return (window.innerWidth > 1000);
   }

   /**
      * Позиционирование тултипа
      * @param {Object} e - объект с параметрами курсора
      */

   setPopupPosition(e) {
      const mouseX = e.clientX + document.body.scrollLeft;
      const mouseY = e.clientY + document.body.scrollTop;

      let top = mouseY + 25;
      let left = mouseX + 15;
      const tooltipHeight = this.$popupInfo.height() + 30;
      const tooltipWidth = this.$popupInfo.width() + 15;

      //условия, чтобы тултип не ушел за вьюпорт
      if ((mouseY + tooltipHeight) > $(window).height()) {
         top = top - tooltipHeight;
      }

      if ((mouseX + tooltipWidth) > $(window).width()) {
         left = left - tooltipWidth;
      }

      const style = {
         left: `${left}px`,
         top: `${top}px`
      };

      this.$popupInfo.css(style);
   }

   /**
      * Показ тултипа
      */
   showPopup() {
      this.$popupInfo.addClass('show');
      setTimeout(() => {
         this.$popupInfo.addClass('show-effect');
      }, 5);
   }

   /**
     * Закрытие тултипа
     */
   hidePopup() {
      if (this.desktop) {
         this.$popupInfo.removeClass('show show-effect');
         this.clearPopup();
      } else {
         this.$popupInfo.removeClass('show-effect');
         setTimeout(() => {
            this.$popupInfo.removeClass('show');
            this.clearPopup();
         }, 400);
      }
   }

   /**
      * Создание тултипа
      * @return {HTMLElement} созданный тултип
      */
   createPopup() {
      $('body').append(`
          <div id="popup_info" class="garage_popup_info">
              <div class="content"></div>
          </div>
      `);

      return $('#popup_info');
   }

   /**
   * Добавление данных в тултип
   * @param {Object} item - svg.js объект
   */

   setDataPopup(item = {}) {
      const href = item.data('href');
      const name = item.data('name');
      const garages = item.data('garages') || [];
      const state = item.data('state');
      const cost = item.data('cost');
      const garageLength = item.data('length');
      const garageWidth = item.data('width');
      const square = item.data('square');
      let string = '';
      if(garageLength != '' && garageWidth != '') {
         string = `<p class="text garage_tooltip_text">Длина: ${garageLength} м</p><p class="text garage_tooltip_text">Ширина: ${garageWidth} м</p>`
      }

      const headHTML = `
       <div class="head">
           <p class="text big garage_tooltip_text">Место № ${name}</p>
           <a href="${href}" class="close hide-desktop" data-close-popup-info><i class="icon icon-close1"></i></a>
           <p class="text garage_tooltip_text">Площадь: ${square} м²</p>` + string +
           `<p class="text garage_tooltip_text">Статус: ${state}</p>
           <p class="text garage_tooltip_cost garage_tooltip_text color-main-active">${numberFormat(cost,0,'',' ')} ₽</p>`;
      const buttonHTML = `
            <div class="text-align-center hide-desktop">
                <a href="${href}" data-open-form class="button inline margin-top margin-bottom-x2 no-margin-horizontal">Продолжить</a>
            </div>
        `;
      const popUpHTML = headHTML + buttonHTML;
      this.$popupInfoContent.html(popUpHTML);
   }

   /**
   * Очистка HTML тултипа
   */
   clearPopup() {
      this.$popupInfoContent.html('');
   }

   clearForm() {
      this.$formInfoContent.html('');
   }
}
